
// all slider
window.SplideSliderFunction = function () {
  document.querySelectorAll('.splide').forEach((element) => {
    const perPage = parseInt(element.dataset.perPage) || 1;
    const gap = element.dataset.gap || '24px';
    const drag = element.dataset.drag === 'true';
    const arrows = element.dataset.arrows === 'true';
    const direction = element.dataset.direction;
    const height = element.dataset.height;
    const autoplay = element.dataset.autoplay === 'true';
    const autoplayintervel = parseInt(element.dataset.autoplayintervel);
    const type = element.dataset.type;
    const paginatione = element.dataset.pagination == 'true';
    
    // Banner check
    const isBanner = element.dataset.banner === 'yes';
    const mobileshow = isBanner ? 1 : 2;

   
    const splide = new Splide(element, {
      type: type,
      perPage: perPage,
      arrows: arrows,
      pagination: paginatione,
      drag: drag,
      autoplay: autoplay,
      gap: gap,
      interval: autoplayintervel || 3000,
      breakpoints: {
        989: {
          pagination: paginatione,
          drag: true,
          perPage: mobileshow,
          gap: "20px"
        },
        767: {
          perPage: mobileshow,
          arrows: arrows,
          pagination: paginatione,
        },
        575: {
          perPage: 1,
          arrows: arrows,
          pagination: paginatione
        }
      }
    });



splide.mount();
    
    
  });
  
};

SplideSliderFunction();



// marquee slider
document.querySelectorAll(".marquee-slider").forEach(function (slider) {
  new Splide(slider, {
    type: "loop",
    perPage: 3,
    arrows: false,
    pagination: false,
    focus: "center",
    gap: "1em"
  }).mount(window.splide.Extensions);
});




// faq details
document.addEventListener("DOMContentLoaded", function (){

     document.querySelectorAll(".question").forEach(function (item){
        item.addEventListener("click", function (){
         this.parentElement.classList.toggle("active");

          // hide show div
         const nextdiv = this.nextElementSibling;
          if (window.getComputedStyle(nextdiv).display == "none"){
               nextdiv.style.display = "block";

          }else{
               nextdiv.style.display = "none";
          }


         // sibling process
         const topparent = this.parentElement.parentElement.children;
        
         for( let i=0; i < topparent.length; i++){  
          const siblingcount = topparent[i]; 
              console.log(siblingcount);
            if(siblingcount != this.parentElement){
               siblingcount.classList.remove("active");
               const dataText = siblingcount.querySelector(".answer");
                dataText.style.display = "none";
            }
         }           
        });

    });
});




// featured collection tab
 document.querySelectorAll(".cmn-tab").forEach(function (item){
      item.addEventListener("click", function(){

        // active class add and remove
        const tabId = this.getAttribute("data-id");
        this.classList.toggle("active");

         const TabParent = Array.from(this.parentElement.children);
          TabParent.forEach(function (sibling) {
            if(sibling != this){
            sibling.classList.remove("active");
            }
          }, this);


        // bottom process
          const nextSibling = Array.from(this.parentElement.nextElementSibling.children);
           nextSibling.forEach(function (infoItem){
                const InfoId = infoItem.getAttribute("data-id");
                if(InfoId == tabId){
                    infoItem.style.display = "block";
                    infoItem.classList.add("active");

                    const infoParent = Array.from(infoItem.parentElement.children);
                     infoParent.forEach(function (infoparentitem){
                        if(infoparentitem != infoItem){
                            infoparentitem.style.display = "none";
                            infoparentitem.classList.remove("active");
                        }
                     });
                 }       
               
           });
     

      });

   });


   // qty cart btn wrap
  const buyBtn = document.querySelector(".gift-card-template .cus-buy-btn");
  const quantity = document.querySelector(".gift-card-template .product-form__quantity");

  if (buyBtn && quantity) {
    const wrapper = document.createElement("div");
    wrapper.className = "custom-buy-wrapper";

    quantity.parentNode.insertBefore(wrapper, quantity);
    wrapper.appendChild(quantity);
    wrapper.appendChild(buyBtn);
  }




function initBundleQty(){

  let radios = document.querySelectorAll('input[name="bundle_qty"]');
  let qtyInput = document.querySelector('#Quantity-' + document.querySelector('product-form').dataset.sectionId);

  function updateQty(qty){
    if(qtyInput){
      qtyInput.value = qty;

      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  radios.forEach(function(radio){

    radio.addEventListener('change', function(){
      updateQty(this.value);
    });

  });

  /* default checked radio */
  let checkedRadio = document.querySelector('input[name="bundle_qty"]:checked');

  if(checkedRadio){
    updateQty(checkedRadio.value);
  }

}

/* first load */
document.addEventListener("DOMContentLoaded", initBundleQty);





// main price set on varinat click
 function setMainPrice(){

  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');

  const variants = document.querySelectorAll('.variants-input');
  const mainPrice = document.querySelector('.main-price');

  if(!variantId || !mainPrice) return;

  variants.forEach(function(variant){
    if(variant.dataset.id === variantId){
      const price = variant.dataset.qty;
      mainPrice.setAttribute('data-price', price);
    }
  });

calculateBundlePrices();

}

document.addEventListener("DOMContentLoaded", setMainPrice);


// percentage calulation
function calculateBundlePrices(){

  const mainPriceInput = document.querySelector('.main-price');
  if(!mainPriceInput) return;

  let basePrice = parseFloat(mainPriceInput.dataset.price);
  if(!basePrice) return;

  /* BUY 5 */
  let price5 = basePrice * 5;
  let el5 = document.querySelector('.bundle-price5');
  if(el5) el5.innerText = "$" + price5.toFixed(2);

  /* BUY 10 */
  let price10 = basePrice * 10;
  let final10 = price10 - (price10 * 2 / 100);

  let el10 = document.querySelector('.bundle-price10');
  if(el10) el10.innerText = "$" + final10.toFixed(2);

  let dis10 = document.querySelector('.bundel-box-wrapper10 .discount-price');
  if(dis10) dis10.innerText = "$" + price10.toFixed(2);
  /* SAVE amount */
  let save10 = price10 - final10;

  let saveText = document.querySelector('.bundel-box-wrapper10 .save-price');
  if(saveText) saveText.innerText = "SAVE $" + save10.toFixed(2);


  /* BUY 25 */
  let price25 = basePrice * 25;
  let final25 = price25 - (price25 * 5 / 100);

  let el25 = document.querySelector('.bundle-price25');
  if(el25) el25.innerText = "$" + final25.toFixed(2);

  let dis25 = document.querySelector('.bundel-box-wrapper25 .discount-price');
  if(dis25) dis25.innerText = "$" + price25.toFixed(2);

  /* BUY 50 */
  let price50 = basePrice * 50;
  let final50 = price50 - (price50 * 10 / 100);

  let el50 = document.querySelector('.bundle-price50');
  if(el50) el50.innerText = "$" + final50.toFixed(2);

  let dis50 = document.querySelector('.bundel-box-wrapper50 .discount-price');
  if(dis50) dis50.innerText = "$" + price50.toFixed(2);
}

calculateBundlePrices();



// close click qty reset 
document.addEventListener("click", function(e){

  const closeBtn = e.target.closest('.drawer__close');
  const overlay = e.target.closest('#CartDrawer-Overlay, .cart-drawer__overlay');

  if(!closeBtn && !overlay) return;

  setTimeout(function(){
    if(typeof initBundleQty === "function"){
      initBundleQty();
    }
    updateBundleButton();
    updateCollectionButtons();

  }, 200);

});





  // cart button js accourdingly qty
async function updateBundleButton() {
   const qtyInput = document.querySelector('.product-qty');
    if (!qtyInput) return;

    const bundleInput = document.querySelector('input[name="bundle_qty"]:checked');
    if (!bundleInput) return;

    const inventory = parseInt(qtyInput.dataset.qty);
    const variantId = parseInt(qtyInput.dataset.variantId);
    const selectedQty = parseInt(bundleInput.value);

    const cart = await fetch('/cart.js').then(res => res.json());

    const cartItem = cart.items.find(item => item.variant_id === variantId);
    const cartQty = cartItem ? cartItem.quantity : 0;

    const remainingQty = inventory - cartQty;

    const addForm = document.querySelector('.cus-addtocartForm');
    const soldOut = document.querySelector('.cus-product-soldout-btn');

    if (remainingQty >= selectedQty) {
        addForm.style.display = '';
        soldOut.style.display = 'none';
    } else {
        addForm.style.display = 'none';
        soldOut.style.display = '';
    }
}

document.querySelectorAll('input[name="bundle_qty"]').forEach(radio => {
    radio.addEventListener('change', updateBundleButton);
});

updateBundleButton();

function updateVariantInventory() {
  
    const selectedOption = document.querySelector(
        'variant-selects input[type="radio"]:checked'
    );

    if (!selectedOption) return;

    const optionValue = selectedOption.value;

    const variant = document.querySelector(
        `.variant-data[data-option="${optionValue}"]`
    );

    if (!variant) return;

    const qtyInput = document.querySelector('.product-qty');

    qtyInput.dataset.variantId = variant.dataset.id;
    qtyInput.dataset.qty = variant.dataset.inventory;

    updateBundleButton();
}





// Collection card product
async function updateCollectionButtons() {
    const cart = await fetch('/cart.js').then(res => res.json());

    document.querySelectorAll('.collection-product-qty').forEach((input) => {

        const inventory = parseInt(input.dataset.inventory);
        const variantId = parseInt(input.dataset.variantId);

        const cartItem = cart.items.find(item => item.variant_id == variantId);
        const cartQty = cartItem ? cartItem.quantity : 0;

        const remainingQty = inventory - cartQty;

        console.log(remainingQty);

        const card = input.closest('.cus-card-wrapper'); // change if needed

        if (!card) return;

        

        const addBtn = card.querySelector('.cus-card-product-btn');
        const soldOutBtn = card.querySelector('.cus-card-product-soldout');

        if (!addBtn || !soldOutBtn) return;
        console.log("work");

        if (remainingQty >= 5) {
            addBtn.style.display = '';
            soldOutBtn.style.display = 'none';
        } else {
            addBtn.style.display = 'none';
            soldOutBtn.style.display = '';
        }
    });
}

// Run on page load
updateCollectionButtons();